import {
    fetchPostFinapiProviderAuthorizationUrl,
    fetchPostTruelayerProviderAuthorizationUrl
} from '@iwoca/lapi-client/edge';

import { TOnlineBankWithProvider } from './BankSelectionModal.types';

export const getBankAuthUrl = async ({
    bank,
    stateKey
}: {
    bank: TOnlineBankWithProvider;
    stateKey: string;
}) => {
    try {
        if (bank.provider === 'truelayer') {
            return await fetchPostTruelayerProviderAuthorizationUrl({
                stateKey,
                providerId: bank.bank_id
            });
        } else if (bank.provider === 'finapi') {
            return await fetchPostFinapiProviderAuthorizationUrl({
                stateKey,
                providerId: bank.bank_id
            });
        } else {
            throw new Error('Unknown provider');
        }
    } catch (err: unknown) {
        throw new Error(
            `Error fetching auth url: ${err instanceof Error ? err.message : 'Unknown error'}`
        );
    }
};
